import useApolloClient from '../hooks/useApolloClient';
import { Route, Switch } from 'react-router-dom';
import { ModeProvider } from '../hooks/useMode';
import Jobs from '../pages/jobs/Jobs';
import Home from '../pages/Home';
import { ApolloProvider } from '@apollo/client';
import React from 'react';
import TesterProfile from './individual/pages/profile/TesterProfile';

const Individual = () => {
  return (
    <ApolloProvider client={useApolloClient('individual')}>
      <ModeProvider value="individual">
        <Switch>
          <Route
            path={['/individual/jobs/:id', '/individual/jobs']}
            component={Jobs}
          />
          <Route path="/individual/profile" component={TesterProfile} />
          <Route path="/individual" component={Home} />
        </Switch>
      </ModeProvider>
    </ApolloProvider>
  );
};

export default Individual;
